var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.915,
    cy: 11.915,
    r: 11.915,
    fill: "#3B5998"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.915,
    cy: 11.915,
    r: 11.915,
    fill: "#5F787E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 12.381h-2.126v7.789H9.563V12.38H8.03V9.644h1.532V7.872c0-1.266.601-3.25 3.25-3.25l2.386.01V7.29h-1.732c-.284 0-.683.142-.683.746v1.611h2.407l-.281 2.735z",
    fill: "#fff"
  })));
}
export default SvgMobileFacebookLogo;